import { makeAutoObservable, runInAction } from "mobx";
import { ONBOARDING_STEPS, PLAN_TYPE } from "../constants";
import { IMerchantOnboarding } from "../onboarding-types";
import OnboardingDataStore, { IGetMerchantOnboardingModel, IMerchantOnboardingChanges, IOnboardingScreenStore } from "./onboarding-data-store";
import onboardingPlansStores from "./onboarding-plans-stores";
import { OnboardingNavigationStore } from "./onboarding-navigation-store";
import { getNullableChangesOrModel } from "../../../models/model-types-methods";
import OnboardingPlansStores from "./onboarding-plans-stores";
import {PlanStore} from "../../subscription-plans/stores/subscription-plans-store";

class ChoosePlanTypeScreenStore implements IOnboardingScreenStore {
    private _changes: IMerchantOnboardingChanges = {};
    private _getModel: IGetMerchantOnboardingModel;
    private _onboardingDataStore: OnboardingDataStore;
    private readonly _stepName: ONBOARDING_STEPS = ONBOARDING_STEPS.CHOOSE_PLAN_TYPE;
    private _isLoading: boolean = false;

    constructor(onboardingDataStore: OnboardingDataStore, private _navigationStore: OnboardingNavigationStore) {
        this._onboardingDataStore = onboardingDataStore;
        this._getModel = this._onboardingDataStore.getModel;
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get planType(): PLAN_TYPE | undefined| null { 
        return getNullableChangesOrModel(this._changes.plan_type, this._getModel()?.plan_type);
    }
    public get isLoading(): boolean { return this._isLoading; }

    public getUpdatedModel(): IMerchantOnboarding {
        return { ...this._getModel(), ...this._changes } as IMerchantOnboarding;
    }

    public getMixPanelData(): Record<string, any> {
        if(this._changes.plan_id) {
            const plan = OnboardingPlansStores.getPlanById(this._changes.plan_id) as PlanStore;
            return {
                selected_plan: {
                    id: plan.id,
                    plan_name: plan.name,
                },
                plan_type: this._changes.plan_type
            }
        }

        return this._changes;
    }

    public hasChanges(): boolean {
        return Object.keys(this._changes).length > 0;
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public isComplete(): boolean {
        return !!this.planType;
    }

    public setPlanType(type: PLAN_TYPE): void {
        this._changes.plan_type = type;
        if (type === PLAN_TYPE.COVERAGE) {
            this._changes.plan_id = onboardingPlansStores.onboardingCoveragePlan?.id;
        }
        else {
            this._changes.plan_id = null;
        }
    }

    public previousStep(): void {
        this._navigationStore.previousStep();
    }

    public async nextStep(): Promise<void> {
        this._isLoading = true;
        await this._onboardingDataStore.save(this._stepName);
        runInAction(() => {
            this._navigationStore.nextStep();
            this._isLoading = false;
        })
    }
}

export default ChoosePlanTypeScreenStore;